// @ts-expect-error: @rails/request.js is not typed
import { FetchRequest } from '@rails/request.js'
import { useMutation } from '@tanstack/react-query'

import { type Transaction } from 'components/brokers/types'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'

type TransactionLossPatchParam = {
  loss_amount: string;
}

export function useModifyTransactionLossAmount ({
  memberId,
  transactionId,
}: {
  memberId: string;
  transactionId: string;
}) {
  return useMutation<Transaction, GrapeAPIErrorType, TransactionLossPatchParam>({
    mutationFn: async (params) => {
      const request = new FetchRequest(
        'post',
       `/api/web/brokers/members/${memberId}/transactions/${transactionId}/mark_loss`,
       {
         headers: {
           'Content-Type': 'application/json',
           Accept: 'application/json',
         },
         body: {
           ...params,
         },
       }
      )
      const response = await request.perform()
      if (!response.ok) {
        const errors = await response.json
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
        })
      }
      return response.json
    },
  })
}
